module.exports = __webpack_public_path__ + "img/souso_bg.eab6a386.3d10b0b6.png";